import React from 'react';
import { Segmented } from 'antd';
import {
  CalendarOutlined,
  AppstoreOutlined,
  IdcardOutlined,
  UnorderedListOutlined
} from '@ant-design/icons';
import './ViewToggle.css';

export type ViewMode = 'cards' | 'day' | 'week' | 'month';

interface ViewToggleProps {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
}

export const ViewToggle: React.FC<ViewToggleProps> = ({ value, onChange }) => {
  return (
    <Segmented
      value={value}
      onChange={(val) => onChange(val as ViewMode)}
      size="large"
      className="view-toggle"
      options={[
        {
          label: 'Cards',
          value: 'cards',
          icon: <IdcardOutlined />
        },
        {
          label: 'Day',
          value: 'day',
          icon: <CalendarOutlined />
        },
        {
          label: 'Week',
          value: 'week',
          icon: <AppstoreOutlined />
        },
        {
          label: 'Month',
          value: 'month',
          icon: <UnorderedListOutlined />
        }
      ]}
    />
  );
};
